<template>
    <div class="modl-tab-body">
        <div class="modl-body">
            <OfflineNotification message="SEARCH_MODAL.OFFLINE_ERROR" />
            <CartOffersCodeSearch :allow-offer-selection="true" />
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>
        </div>
    </div>
</template>

<script>

import CartOffersCodeSearch from '@/epos/vue/modals/CartOffers/CartOffersCodeSearch';
import OfflineNotification from '@/epos/vue/components/Generic/OfflineNotification';

export default {
    components: {
        CartOffersCodeSearch,
        OfflineNotification,
    },

    emits: [
        'cancel',
    ],
};
</script>
